module.exports = __webpack_public_path__ + "static/media/NonWOrdInstruction.2627ead2.mp3";